import { useState } from "react";
import { ClipboardCheck } from "lucide-react";
import BookingCardShell, { Detail, DetailRow } from "./BookingCardShell";

const BookingSummaryCard = ({ content }: any) => {
  const [expanded, setExpanded] = useState(false);

  const parseBookingSummary = (text) => {
    if (!text) return {};
    const details: Record<string, any> = {};
    const lines = text.split("\n").filter((l) => l.trim());

    lines.forEach((line) => {
      // Strip only markdown bold markers (**label**) around keys, preserve asterisks in values
      const cleaned = line.replace(/\*\*([^*]+)\*\*/g, "$1").trim();

      if (cleaned.startsWith("Room:")) {
        details.room = cleaned.replace("Room:", "").trim();
      } else if (cleaned.startsWith("Check-in:")) {
        details.checkIn = cleaned.replace("Check-in:", "").trim();
      } else if (cleaned.startsWith("Check-out:")) {
        details.checkOut = cleaned.replace("Check-out:", "").trim();
      } else if (cleaned.startsWith("Guests:")) {
        details.guests = cleaned.replace("Guests:", "").trim();
      } else if (cleaned.startsWith("Total:")) {
        details.total = cleaned.replace("Total:", "").trim();
      } else if (cleaned.startsWith("- Name:")) {
        details.guestName = cleaned.replace("- Name:", "").trim();
      } else if (cleaned.startsWith("- Email:")) {
        details.email = cleaned.replace("- Email:", "").trim();
      } else if (cleaned.startsWith("- Phone:")) {
        details.phone = cleaned.replace("- Phone:", "").trim();
      } else if (cleaned.startsWith("-") && cleaned.includes(",")) {
        if (!details.billingLines) details.billingLines = [];
        details.billingLines.push(cleaned.replace(/^-\s*/, "").trim());
      }
    });

    return details;
  };

  const details = parseBookingSummary(content);
  const headerSummary = [details.room, details.total].filter(Boolean).join(" | ");

  return (
    <BookingCardShell
      icon={<ClipboardCheck />}
      tone="warning"
      title="Booking Summary"
      meta={headerSummary}
      expanded={expanded}
      onToggle={() => setExpanded(!expanded)}
    >
      {details.room || details.checkIn || details.total ? (
        <>
          <DetailRow>
            {details.room && <Detail label="Room"><strong>{details.room}</strong></Detail>}
            {details.checkIn && <Detail label="Check-in">{details.checkIn}</Detail>}
            {details.checkOut && <Detail label="Check-out">{details.checkOut}</Detail>}
          </DetailRow>
          <DetailRow>
            {details.guests && <Detail label="Guests">{details.guests}</Detail>}
            {details.total && <Detail className="font-semibold">{details.total}</Detail>}
          </DetailRow>
          {(details.guestName || details.email || details.phone || details.billingLines) && (
            <div className="grid gap-3 border-t border-border pt-2 sm:grid-cols-2">
              {(details.guestName || details.email || details.phone) && (
                <div>
                  <p className="text-xs font-medium uppercase tracking-wide text-muted-foreground">Guest</p>
                  <p>
                    {details.guestName}
                    {details.phone && <span className="text-muted-foreground"> &bull; {details.phone}</span>}
                  </p>
                  {details.email && <p className="text-muted-foreground">{details.email}</p>}
                </div>
              )}
              {details.billingLines && details.billingLines.length > 0 && (
                <div>
                  <p className="text-xs font-medium uppercase tracking-wide text-muted-foreground">Billing</p>
                  <p>{details.billingLines.join(", ")}</p>
                </div>
              )}
            </div>
          )}
        </>
      ) : (
        <p className="whitespace-pre-wrap">{content}</p>
      )}
    </BookingCardShell>
  );
};

export default BookingSummaryCard;
